<template>
<button @click="mainStore.showQuestions = !mainStore.showQuestions" data-drawer-target="default-sidebar" data-drawer-toggle="default-sidebar" aria-controls="default-sidebar" type="button" class="inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
    <span class="sr-only">Open sidebar</span>
    <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path clip-rule="evenodd" fill-rule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
    </svg>
</button>


<ExamQuestions />

<div class="lg:ml-[25em] xs:ml-0">

    <Transition name="list" mode="out-in">
        <component :is="mainStore.currentView">
            <PreTestInstructions v-if="mainStore.currentView == 'instructions'" key="1" />
            <QuizDetail v-else-if="mainStore.currentView == 'exam'" key="2" />
            <Results v-else-if="mainStore.currentView == 'results'" key="3" />
            <EmptyView v-else key="4" />
        </component>

    </Transition>

</div>

<!-- component -->
<div v-if="mainStore.showMessageModal" class="fixed left-0 top-0 flex h-full w-full items-center justify-center bg-black bg-opacity-50 py-10 z-[9999]">
    <div class="max-h-full w-full max-w-xl overflow-y-hidden sm:rounded-2xl bg-white">
        <div class="w-full">
            <div class="m-8 my-16 max-w-[400px] mx-auto">
                <div class="mb-8">
                    <h1 class="mb-4 text-3xl font-extrabold">{{ this.mainStore.displayTitle }}</h1>
                    <p class="text-gray-600 text-lg">{{ this.mainStore.displayMessage }}</p>
                </div>
                <div class="space-y-4">
                    <button v-if="mainStore.displayReturnButton" @click="mainStore.showMessageModal = false" class="p-3 bg-black rounded-full text-white w-full font-semibold">Return to Exam</button>
                    <button v-if="mainStore.displaySubmitButton" @click="submitExam(this.$route.params.id)" class="p-3 bg-black rounded-full text-white w-full font-semibold">Submit Exam</button>
                    <button v-if="mainStore.displayCancelButton" @click="mainStore.showMessageModal = false" class="p-3 bg-white border rounded-full w-full font-semibold">Cancel</button>
                    <div v-if="mainStore.displayIsSendingExam" class="">
                        <div role="status">
                            <svg aria-hidden="true" class="inline w-12 h-12 mr-2 text-gray-200 mx-auto w-full animate-spin dark:text-gray-600 fill-black" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                            </svg>
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div v-show="mainStore.showNotes" class="relative z-[9999]" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
  <!-- Background backdrop, show/hide based on slide-over state. -->
  <div class="fixed inset-0 bg-black bg-opacity-40 animate__animated animate__faster" :class="mainStore.showNotes ? 'animate__fadeIn' : 'animate__fadeOut'"></div>

  <div class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">
      <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">

        <div class="pointer-events-auto w-screen max-w-md animate__animated animate__faster" :class="mainStore.showNotes ? 'animate__fadeInRight' : 'animate__fadeOutRight'">
            <div class="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
            <div class="h-0 flex-1 overflow-y-auto">
              <div class="bg-gray-100 px-4 py-6 sm:px-6">
                <div class="flex items-center justify-between">
                  <h2 class="text-base font-semibold leading-6 text-black" id="slide-over-title">New Note</h2>
                  <div class="ml-3 flex h-7 items-center">
                    <button @click="mainStore.showNotes = false" type="button" class="rounded-md text-black hover:text-white focus:outline-none focus:ring-2 focus:ring-white">
                      <span class="sr-only">Close panel</span>
                      <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="mt-1">
                  <p class="text-sm text-black">You can use this for rules references, thoughts, etc. </p>
                </div>
              </div>
              <div class="flex flex-1 flex-col justify-between">
                <div class="divide-y divide-gray-200 px-4 sm:px-6">
                  <div class="space-y-6 pb-5 pt-6">

                    <div>
                      <label for="description" class="block text-sm font-medium leading-6 text-gray-900">Note</label>
                      <div class="mt-2">
                        <textarea v-model="mainStore.currentNote" name="description" rows="4" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-700 sm:text-sm sm:leading-6"></textarea>
                      </div>
                    </div>
            
                
                  </div>
               
                </div>
              </div>
            </div>
            <div class="flex flex-shrink-0 justify-end px-4 py-4">
              <button @click="mainStore.showNotes = false" type="button" class="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Cancel</button>
              <button @click="saveNote()" type="submit" class="ml-4 inline-flex justify-center rounded-md bg-gray-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-800">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



</template>

<script>
import {
    mapStores,
    mapActions
} from "pinia";

import useMainStore from "@/stores/main";
import QuizDetail from "../components/QuizDetail.vue";
import PreTestInstructions from "../components/PreTestInstructions.vue";
import Results from "../components/Results.vue";
import EmptyView from "../components/EmptyView.vue";
import ExamQuestions from "../components/ExamQuestions.vue";

export default {
    data() {
        return {
            totalQuestions: 0,
            showQuestions: false,
        }
    },
    components: {
    QuizDetail,
    PreTestInstructions,
    Results,
    EmptyView,
    ExamQuestions
},
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        ...mapActions(useMainStore, ['submitExam', 'loadAndOpenNote', 'flag', 'updateUserProgress']),
        saveNote() {
            if (this.mainStore.currentNote == '') {
                return this.mainStore.showNotes = false
            }
            if (this.mainStore.notes.map(item => item.id).indexOf(this.mainStore.questions[this.mainStore.index].id) == -1) {
                this.mainStore.notes.push({
                    id: this.mainStore.current.id,
                    question: this.mainStore.current.question,
                    text: this.mainStore.currentNote,
                })
            } else {
                this.mainStore.notes[this.mainStore.notes.map(item => item.id).indexOf(this.mainStore.questions[this.mainStore.index].id)].text = this.mainStore.currentNote
            }
            this.mainStore.showNotes = false
            this.updateUserProgress(this.exam_id)
        },
        goBack() {
            if (this.mainStore.index == 0) return
            this.mainStore.index--
            this.mainStore.current = this.mainStore.questions[this.mainStore.index]
            
            const answeredIndex = this.mainStore.answeredQuestions.map(item => item.question).indexOf(this.mainStore.questions[this.mainStore.index].question)
            if (answeredIndex == -1) {
                this.mainStore.selectedChoice = ''
            } else {
                const answeredQuestion = this.mainStore.answeredQuestions[answeredIndex]
                const currentQuestion = this.mainStore.questions[this.mainStore.index]
                
                // Validate if the answer is still valid for current question
                if (this.mainStore.isAnswerValid(answeredQuestion, currentQuestion)) {
                    this.mainStore.selectedChoice = answeredQuestion.answer
                } else {
                    this.mainStore.selectedChoice = ''
                }
            }
            
            this.updateUserProgress(this.$route.params.id)
        },
        goToNext() {
            if (this.mainStore.index == this.mainStore.questions.length - 1) return
            this.mainStore.index++
            this.mainStore.current = this.mainStore.questions[this.mainStore.index]

            const answeredIndex = this.mainStore.answeredQuestions.map(item => item.question).indexOf(this.mainStore.questions[this.mainStore.index].question)
            if (answeredIndex == -1) {
                this.mainStore.selectedChoice = ''
            } else {
                const answeredQuestion = this.mainStore.answeredQuestions[answeredIndex]
                const currentQuestion = this.mainStore.questions[this.mainStore.index]
                
                // Validate if the answer is still valid for current question
                if (this.mainStore.isAnswerValid(answeredQuestion, currentQuestion)) {
                    this.mainStore.selectedChoice = answeredQuestion.answer
                } else {
                    this.mainStore.selectedChoice = ''
                }
            }
            
            this.updateUserProgress(this.$route.params.id)
        },
    },
    async mounted() {

        window.addEventListener('keydown', (e) => {
            if (e.key.toLowerCase() == 'arrowright') {
                this.goToNext()
            }
        });
        window.addEventListener('keydown', (e) => {
            if (e.key.toLowerCase() == 'arrowleft') {
                this.goBack()
            }
        });

        if (this.mainStore.questions.length != 0) {
            this.mainStore.current = this.mainStore.questions[this.mainStore.index]
            this.selectQuestion(this.mainStore.current, this.mainStore.questions.indexOf(this.mainStore.questions[this.mainStore.index]))
        }
    

    },

}
</script>

<style>
.slide-fade-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.2s linear;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(30px);
    opacity: 0;
}

.slide-fade-leave-active {
    transition: all 0.7s linear;
}

.list-enter-active,
.list-leave-active {
    transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

.font-enter-active,
.font-leave-active {
    transition: all 0.3s ease;
}

.font-enter-from,
.font-leave-to {
    opacity: 0;
    transform: translateX(15px);
}

/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #909090;
    border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
:root {
  --animate-duration: 0.2s;
}
</style>
